// extracted by mini-css-extract-plugin
export default {"lanscapeAboutLandscapeWrapper":"LandscapeAboutLandscapePage_lanscapeAboutLandscapeWrapper__n7zW+"};